import React, { useState } from "react";
import { launchModule } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { toast } from "sonner";
import { ExternalLink } from "lucide-react";

export function OpenModuleButton({ moduleKey, name = "", className = "" }) {
  const { lang } = useI18n();
  const [loading, setLoading] = useState(false);

  const open = async () => {
    setLoading(true);
    const res = await launchModule(moduleKey);
    if (!res.ok) {
      toast.error(res.message || (lang === "en" ? "Unable to open the module." : "Impossible d'ouvrir le module."));
      setLoading(false);
    }
  };

  const label = loading
    ? lang === "en" ? "Opening…" : "Ouverture…"
    : lang === "en" ? `Open ${name}` : `Ouvrir ${name}`;

  return (
    <button
      data-testid={`open-module-sso-${moduleKey}`}
      onClick={open}
      disabled={loading}
      className={`inline-flex items-center justify-center gap-2 rounded-md h-10 font-semibold bg-[#EAB308] text-black hover:opacity-90 transition-opacity disabled:opacity-60 ${className}`}
    >
      {!loading && <ExternalLink className="w-4 h-4" />} {label}
    </button>
  );
}
